const SERVER_URL = process.env.REACT_APP_SERVER_URL;

const handleUserLogin = async (email, password) => {
    try {
        const res = await fetch('/auth/login', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email, password }),
        });
        const data = await res.json();
        return data;
    } catch(err) {
        console.error(err);
    }
};

const fetchStudentVideoUploads = async (username) => {
    try {
        const resp = await fetch(`${SERVER_URL}/student/${encodeURIComponent(username)}/uploads`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include'
        })
        if (resp.ok) {
            return resp.json();
        } else {
            throw new Error(`Error fetching student video recordings for ${username}: ${resp.status}`);

        }
    } catch(err) {
        throw err;
    }
}

const fetchStudentVideoDownloadUrl = async (username, key) => {
    const resp = await fetch(`${SERVER_URL}/student/${encodeURIComponent(username)}/uploads/download?key=${encodeURIComponent(key)}`, {
        method: 'GET',
        credentials: 'include',
    });
    if (!resp.ok) {
        throw new Error(`Error fetching download URL for ${key}: ${resp.status}`);
    }
    const { url } = await resp.json();
    return url;
}

const fetchStudentVideoStreamUrl = async (username, key) => {
    const resp = await fetch(`${SERVER_URL}/student/${encodeURIComponent(username)}/uploads/stream?key=${encodeURIComponent(key)}`, {
        method: 'GET',
        credentials: 'include',
    });
    if (!resp.ok) {
        throw new Error(`Error fetching stream URL for ${key}: ${resp.status}`);
    }
    const { url } = await resp.json();
    return url;
}

module.exports = { handleUserLogin, fetchStudentVideoUploads, fetchStudentVideoDownloadUrl, fetchStudentVideoStreamUrl };